import { StaticImageData } from 'next/image'

export enum PupKeywordEmoji {
  BEATING_HEART = 'beating_heart',
  BOOKS = 'books',
  BREAD = 'bread',
  CAKE = 'cake',
  CAMERA_WITH_FLASH = 'camera_with_flash',
  CAMPING = 'camping',
  CHECK_MARK = 'check_mark',
  COCKTAIL = 'cocktail',
  COIN = 'coin',
  FACE_SHUSHING = 'face_shushing',
  FACE_SMILING_BIG = 'face_smiling_big',
  FACE_STAR_STRUCK_BIG = 'face_star_struck_big',
  FACE_WITH_GLASSES_BIG = 'face_with_glasses_big',
  FACE_WITH_SUNGLASSES = 'face_with_sunglasses',
  FACE_WITH_SUNGLASSES_BIG = 'face_with_sunglasses_big',
  FACE_WITH_THUMBSUP_BIG = 'face_with_thumbsup_big',
  FERRIS_WHEEL = 'ferris_wheel',
  FIRE = 'fire',
  FLAG_IN_HOLE = 'flag_in_hole',
  GREEN_HEART = 'green_heart',
  HIGH_VOLTAGE = 'high_voltage',
  JAPANESE_RAMEN = 'japanese_ramen',
  KOREAN_STEW = 'korean_stew',
  LOCATION = 'location',
  MAP_PIN_MARK = 'map_pin_mark',
  PARTY_POPPER = 'party_popper',
  SKI = 'ski',
  SPARKLES = 'sparkles',
  SPEECH_BALLON = 'speech_balloon',
  STEAK = 'steak',
  SUSHI = 'sushi',
  TTEOKBOKKI = 'tteokbokki',
  TWO_HEARTS = 'two_hearts',
}

const PupKeywordEmojiPath = `https://ssl.pstatic.net/static/pup/emoji/`

const isStaticImageData = (image: any): image is StaticImageData => {
  return !!image?.src
}

const isPupKeywordEmoji = (image: any): image is PupKeywordEmoji => {
  return Object.values(PupKeywordEmoji).includes(image)
}

export const convertImageUrl = (image: string | StaticImageData | PupKeywordEmoji): string => {
  if (isStaticImageData(image)) return image.src

  if (isPupKeywordEmoji(image)) return `${PupKeywordEmojiPath}${image}.png`

  return image
}
